import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Save } from 'lucide-react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { z } from 'zod';
import { dogCreateSchema, dogUpdateSchema, type DogUpdate } from '../../../../../packages/contracts/src/index.js';
import { Button } from '../../components/ui/button';
import { ErrorState, LoadingState } from '../../components/ui/state';
import { api } from '../../shared/api';
import { DogFields, DogFormShell } from './DogCreatePage';

type DogFormInput = z.input<typeof dogCreateSchema>;
type DogFormOutput = z.output<typeof dogCreateSchema>;

export function DogEditPage() {
  const { dogId = '' } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const dogQuery = useQuery({ queryKey: ['dog', dogId], queryFn: () => api.dogs.get(dogId), enabled: Boolean(dogId) });
  const form = useForm<DogFormInput, unknown, DogFormOutput>({ resolver: zodResolver(dogCreateSchema), defaultValues: { customerId: '', name: '', sex: 'unknown', vaccinationFileIds: [], sterilized: false, careStatus: 'other', status: 'active' } });
  useEffect(() => { if (dogQuery.data) form.reset(dogQuery.data); }, [dogQuery.data, form]);
  const updateDog = useMutation({
    mutationFn: (values: DogUpdate) => api.dogs.update(dogId, dogUpdateSchema.parse(values)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['dogs'] });
      navigate('/admin/dogs');
    },
  });

  if (dogQuery.isLoading) return <LoadingState label="Cargando perro" />;
  if (dogQuery.isError) return <ErrorState message={dogQuery.error.message} />;

  return (
    <DogFormShell title="Editar perro">
      <form className="grid gap-3" onSubmit={form.handleSubmit((values) => updateDog.mutate(values))}>
        <DogFields form={form} />
        {updateDog.isError ? <p className="text-sm text-rose-600">{updateDog.error.message}</p> : null}
        <Button type="submit" disabled={updateDog.isPending}><Save className="h-4 w-4" aria-hidden="true" />Guardar cambios</Button>
      </form>
    </DogFormShell>
  );
}
